/*
 * � 2020 Microsoft. All rights reserved.
 */

define('artassets',['text!artassets.json'], function(aa) {
    return JSON.parse(aa);
});
